export default "__VITE_ASSET__lccGqPYB__"